module.exports = __webpack_public_path__ + "static/media/Poppies-BBC.1ab3196b.jpg";